import { render, staticRenderFns } from "./mobileService.vue?vue&type=template&id=659cbfb1&scoped=true&"
import script from "./mobileService.vue?vue&type=script&lang=js&"
export * from "./mobileService.vue?vue&type=script&lang=js&"
import style0 from "./mobileService.vue?vue&type=style&index=0&id=659cbfb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659cbfb1",
  null
  
)

export default component.exports